(function () {
  'use strict';

  /* FAQ / disclosure accordions — one open at a time per group */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-acc]');
    if (!t) return;
    var item = t.closest('.tpc-acc__item');
    if (!item) return;
    var open = item.classList.toggle('is-open');
    t.setAttribute('aria-expanded', open ? 'true' : 'false');
    var body = item.querySelector('.tpc-acc__panel');
    if (body) body.style.maxHeight = open ? body.scrollHeight + 'px' : '0px';
  });

  /* Marquee: duplicate track once so the loop is seamless */
  document.querySelectorAll('.tpc-marquee__track').forEach(function (track) {
    var clone = track.cloneNode(true);
    clone.setAttribute('aria-hidden', 'true');
    track.parentNode.appendChild(clone);
  });


  /* Header chrome: measure the announcement bar so the header pins directly beneath it,
     and hide the header while scrolling down, reveal it on any scroll up. Without JS the
     header is still sticky and still below the bar (the CSS fallback covers it). */
  var announceEl = document.querySelector('.tpc-announce');
  if (announceEl) {
    var setAnnounceH = function () {
      document.documentElement.style.setProperty('--announce-h', announceEl.offsetHeight + 'px');
    };
    setAnnounceH();
    window.addEventListener('resize', setAnnounceH);
  }

  var headerEl = document.querySelector('.tpc-header');
  if (headerEl) {
    var lastY = window.scrollY, ticking = false, HIDE_AFTER = 120, DELTA = 6;
    var onScroll = function () {
      var y = window.scrollY;
      if (Math.abs(y - lastY) > DELTA) {
        if (y > lastY && y > HIDE_AFTER) headerEl.classList.add('is-hidden');
        else headerEl.classList.remove('is-hidden');
        lastY = y;
      }
      ticking = false;
    };
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; window.requestAnimationFrame(onScroll); }
    }, { passive: true });
  }

  /* Sticky add-to-cart bar on product pages.
     A scroll check, not an IntersectionObserver: the observer silently never fired for
     this element (and for the section reveal), which leaves the bar permanently hidden.
     This costs one getBoundingClientRect per frame and always works. */
  var bar = document.querySelector('[data-sticky-atc]');
  var buyBox = document.querySelector('[data-buy-box]');
  if (bar && buyBox) {
    var stickyTick = false;
    var checkBar = function () {
      var r = buyBox.getBoundingClientRect();
      /* shown once the buy box has scrolled past, hidden once it is back in view */
      bar.classList.toggle('is-visible', r.bottom < 0);
      stickyTick = false;
    };
    window.addEventListener('scroll', function () {
      if (stickyTick) return;
      stickyTick = true;
      requestAnimationFrame(checkBar);
    }, { passive: true });
    window.addEventListener('resize', function () { checkBar(); }, { passive: true });
    checkBar();
  }

  /* Quantity steppers */
  document.querySelectorAll('[data-qty]').forEach(function (wrap) {
    var input = wrap.querySelector('input');
    if (!input) return;
    wrap.addEventListener('click', function (e) {
      var b = e.target.closest('button[data-step]');
      if (!b) return;
      var next = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(b.dataset.step, 10));
      input.value = next;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  /* Hero gallery: the thumbnails, the swipe, and the rail's slow drift */
  document.querySelectorAll('[data-gallery]').forEach(function (g) {
    var main = g.querySelector('[data-gallery-main]');
    var rail = g.querySelector('.tpc-gallery__thumbs');
    var driftOff = false;

    var thumbs = function () { return [].slice.call(g.querySelectorAll('[data-gallery-thumb]')); };

    var show = function (t) {
      if (!t || !main) return;
      driftOff = true;
      main.src = t.dataset.full || t.src;
      main.srcset = t.dataset.srcset || '';
      thumbs().forEach(function (x) { x.classList.remove('is-active'); });
      t.classList.add('is-active');
      if (rail) t.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    };

    var step = function (dir) {
      var list = thumbs();
      if (list.length < 2) return;
      var i = 0;
      list.forEach(function (x, n) { if (x.classList.contains('is-active')) i = n; });
      show(list[(i + dir + list.length) % list.length]);
    };

    g.addEventListener('click', function (e) {
      var t = e.target.closest('[data-gallery-thumb]');
      if (t) show(t);
    });

    /* SWIPE THE BIG IMAGE to move through the set, forwards and back. It needs 40px of horizontal
       travel AND to be clearly more sideways than vertical, so a vertical scroll that drifts a
       little never changes the photo under someone's thumb. Wraps at both ends. Bound to the main
       image only: the thumb rail is a horizontal scroller in its own right and would fight this. */
    var box = g.querySelector('.tpc-gallery__main') || g;
    var x0 = null, y0 = null;
    box.addEventListener('touchstart', function (e) {
      if (e.touches.length === 1) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }
      else { x0 = null; }
    }, { passive: true });
    box.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var t = e.changedTouches[0], dx = t.clientX - x0, dy = t.clientY - y0;
      x0 = null;
      if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy) * 1.2) return;
      step(dx < 0 ? 1 : -1);
    }, { passive: true });

    /* The same move from the keyboard, on whichever thumbnail holds focus. */
    g.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
      step(e.key === 'ArrowRight' ? 1 : -1);
      e.preventDefault();
    });

    /* The thumbnail rail drifts slowly while nobody is using it, so a row that runs off the edge
       looks like a row and not like the end of the list. Any touch, hover, focus, wheel or a
       deliberate image change stops it for good - it never fights the person using it - and it
       does not run at all for anyone who has asked for reduced motion, or when the row fits. */
    if (rail && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      var dir = 1;
      ['pointerdown', 'touchstart', 'mouseenter', 'wheel', 'focusin'].forEach(function (ev) {
        rail.addEventListener(ev, function () { driftOff = true; }, { passive: true });
      });
      setInterval(function () {
        var max = rail.scrollWidth - rail.clientWidth;
        if (driftOff || max <= 2) return;
        if (dir > 0 && rail.scrollLeft >= max - 0.5) dir = -1;
        if (dir < 0 && rail.scrollLeft <= 0.5) dir = 1;
        rail.scrollLeft = Math.max(0, Math.min(max, rail.scrollLeft + 0.8 * dir));
      }, 40);
    }
  });

  /* Countdown (announcement bar) */
  document.querySelectorAll('[data-countdown]').forEach(function (el) {
    var end = new Date();
    end.setHours(23, 59, 59, 999);
    var pad = function (n) { return String(n).padStart(2, '0'); };
    var tick = function () {
      var d = Math.max(0, end - new Date());
      var h = Math.floor(d / 3.6e6), m = Math.floor(d % 3.6e6 / 6e4), s = Math.floor(d % 6e4 / 1e3);
      el.querySelectorAll('[data-h]').forEach(function (n) { n.textContent = pad(h); });
      el.querySelectorAll('[data-m]').forEach(function (n) { n.textContent = pad(m); });
      el.querySelectorAll('[data-s]').forEach(function (n) { n.textContent = pad(s); });
    };
    tick(); setInterval(tick, 1000);
  });
})();
